import ReactDOM from 'react-dom/client';

import { deleteLocal, emptyLocal, getLocal, setLocal } from './utils/api';

import AuthGate from './AuthGate';
import reportWebVitals from './reportWebVitals';
import appInsights from './appInsights';

import './index.css';

const locationParts = window.location.pathname.split('/');

if (locationParts.length === 2 && locationParts[1] === '') {
  deleteLocal('connection');
  deleteLocal('signup');

  const logout = getLocal('logout');

  if (logout) {
    emptyLocal();
    window.location = `/${logout}`;
  }
}

if (locationParts.length === 3 && locationParts[1] === 'referral' && locationParts[2]) {
  setLocal('referralCode', locationParts[2]);
}

if (locationParts.length === 2 && locationParts[1] === 'demo') {
  setLocal('demo', 'demo');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AuthGate />);

reportWebVitals(({ name, value, id }) => {
  appInsights?.trackMetric(
    { name, average: value },
    { metricId: id }
  );
});